import { useEffect } from 'react';

const PerformanceMonitor = () => {
    useEffect(() => {
        // Monitoramento de Web Vitals
        if ('PerformanceObserver' in window) {
            // Medir Largest Contentful Paint (LCP)
            const lcpObserver = new PerformanceObserver((list) => {
                const entries = list.getEntries();
                const lastEntry = entries[entries.length - 1];
                console.log('LCP:', lastEntry.startTime);
            });
            lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });

            // Medir First Input Delay (FID)
            const fidObserver = new PerformanceObserver((list) => {
                const entries = list.getEntries();
                entries.forEach((entry) => {
                    const firstInputEntry = entry as PerformanceEventTiming;
                    console.log('FID:', firstInputEntry.processingStart - firstInputEntry.startTime);
                });
            });
            fidObserver.observe({ entryTypes: ['first-input'] });

            // Medir Cumulative Layout Shift (CLS)
            let clsValue = 0;
            const clsObserver = new PerformanceObserver((list) => {
                for (const entry of list.getEntries()) {
                    if (!(entry as any).hadRecentInput) {
                        clsValue += (entry as any).value;
                        console.log('CLS:', clsValue);
                    }
                }
            });
            clsObserver.observe({ entryTypes: ['layout-shift'] });

            // Medir Time to First Byte (TTFB)
            const navigationEntry = performance.getEntriesByType('navigation')[0];
            if (navigationEntry) {
                const ttfb = (navigationEntry as any).responseStart - (navigationEntry as any).requestStart;
                console.log('TTFB:', ttfb);
            }
        }

        // Performance de carregamento de recursos
        const resourceObserver = new PerformanceObserver((list) => {
            const entries = list.getEntries();
            entries.forEach((entry) => {
                if (entry.duration > 1000) { // Log de recursos lentos
                    console.warn(`Slow resource: ${entry.name} took ${entry.duration}ms`);
                }
            });
        });
        resourceObserver.observe({ entryTypes: ['resource'] });

        // Uso de memória (se disponível)
        if ('memory' in performance) {
            const memory = (performance as any).memory;
            console.log('Memory usage:', {
                used: Math.round(memory.usedJSHeapSize / 1048576) + 'MB',
                total: Math.round(memory.totalJSHeapSize / 1048576) + 'MB',
                limit: Math.round(memory.jsHeapSizeLimit / 1048576) + 'MB'
            });
        }

        // Informação de rede
        if ('connection' in navigator) {
            const connection = (navigator as any).connection;
            if (connection) {
                console.log('Network info:', {
                    effectiveType: connection.effectiveType,
                    downlink: connection.downlink,
                    rtt: connection.rtt,
                    saveData: connection.saveData
                });
            }
        }

    }, []);

    return null; // Este componente não renderiza nada
};

export default PerformanceMonitor;
